import { useContext, useState, FC, useEffect } from 'react'

import { UnifiedPerson, UnifiedPersonFilterKeyString } from 'CitizenProfile/types'
import {
  UNIFIED_PERSON_INITIAL_FILTER,
  UNIFIED_PERSON_INITIAL_PAGINATION,
} from 'CitizenProfile/constants/pages/unifiedPeople'
import { parserUnifiedPersonFilter } from 'CitizenProfile/utils/parserUnifiedPersonFilter'
import CustomFormUnifiedPersonSelectionDrawerManagerContext from './Context'
import readUnifiedPeopleOnCustomForm from './services/readUnifiedPeopleOnCustomForm'

type Props = {
  questionKey: string
  children: JSX.Element
}

const CustomFormUnifiedPersonSelectionDrawerManagerProvider: FC<Props> = ({ questionKey, children }) => {
  const [view, setView] = useState<string>('SEARCH_UNIFIED_PERSON')
  const [selectedUnifiedPerson, setSelectedUnifiedPerson] = useState<UnifiedPerson>({})
  const [loadingUnifiedPeople, setLoadingUnifiedPeople] = useState<boolean>(true)
  const [unifiedPeople, setUnifiedPeople] = useState<UnifiedPerson[]>([])
  const [invalidUnifiedPerson, setInvalidUnifiedPerson] = useState<boolean>(false)
  const [filter, setFilter] = useState<UnifiedPersonFilterKeyString>(UNIFIED_PERSON_INITIAL_FILTER)

  async function loadUnifiedPerson() {
    setLoadingUnifiedPeople(true)
    const filters = {
      filter: parserUnifiedPersonFilter({ filter }),
      pagination: {
        page: 1,
        limit: 100,
        sort: UNIFIED_PERSON_INITIAL_PAGINATION.sort,
      },
    }

    const response = await readUnifiedPeopleOnCustomForm({ filters })

    if (response?.header?.success) {
      const unifiedPeopleFromAPI = response?.body?.unified_person?.elements
      setUnifiedPeople(unifiedPeopleFromAPI || [])
      setInvalidUnifiedPerson(false)
    } else {
      setInvalidUnifiedPerson(true)
    }
    setLoadingUnifiedPeople(false)
  }

  useEffect(() => {
    if (view != 'SEARCH_UNIFIED_PERSON') loadUnifiedPerson()
  }, [filter])

  return (
    <CustomFormUnifiedPersonSelectionDrawerManagerContext.Provider
      value={{
        view,
        setView,
        selectedUnifiedPerson,
        setSelectedUnifiedPerson,
        filter,
        setFilter,
        questionKey,
        unifiedPeople,
        loadingUnifiedPeople,
        invalidUnifiedPerson,
      }}
    >
      {children}
    </CustomFormUnifiedPersonSelectionDrawerManagerContext.Provider>
  )
}

export const useCustomFormUnifiedPersonSelectionDrawerManager = () =>
  useContext(CustomFormUnifiedPersonSelectionDrawerManagerContext)

export default CustomFormUnifiedPersonSelectionDrawerManagerProvider
